import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";


(function ($) {



    $(document).on('ready', function () {

        if ( typeof Swiper === "undefined")
            return;


        $(".case-studies__carousel--active").each(function () {
            const $el = $(this);

            let caseStudiesCarousel = null;

            const desktopMediaQueryList = window.matchMedia("(min-width: 1024px)");

            const destroyOnDesktop = parseInt($el.data('destroy-on-desktop')) === 1;

            const paginationEl = document.getElementById($el.data('pagination-id'));


            function enable() {
                if (caseStudiesCarousel) return;

                caseStudiesCarousel = new Swiper($el.get(0), {
                    modules: [Autoplay, Pagination],
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 1000,
                    allowTouchMove: true,
                    watchOverflow: false,
                    pagination: {
                        type: "bullets",
                        el: paginationEl,
                        clickable: true,
                        enabled: true,
                    },
                    autoplay: {
                        delay: 5000,
                    },
                    breakpoints: {
                        // >= 640px
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 18,
                        },
                        // >= 1024px
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                            pagination: {
                                enabled: false,
                            },
                        },
                    },

                });
            }

            function disable() {
                if (!caseStudiesCarousel) return;

                caseStudiesCarousel.destroy(true, true);
                caseStudiesCarousel = null;
            }

            function check() {
                if (desktopMediaQueryList.matches && destroyOnDesktop) disable();
                else enable();
            }

            // initial check
            check();

            // on resize / breakpoint change
            desktopMediaQueryList.addEventListener?.("change", check) || desktopMediaQueryList.addListener(check);
        });



        $(".info-cards__carousel--active").each(function () {
            const $el = $(this);

            let infoCardsCarousel = null;

            const desktopMediaQueryList = window.matchMedia("(min-width: 1024px)");

            const destroyOnDesktop = parseInt($el.data('destroy-on-desktop')) === 1;

            const paginationEl = document.getElementById($el.data('pagination-id'));


            function enable() {
                if (infoCardsCarousel) return;

                infoCardsCarousel = new Swiper($el.get(0), {
                    modules: [Autoplay, Pagination],
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 1000,
                    allowTouchMove: true,
                    watchOverflow: false,
                    pagination: {
                        type: "bullets",
                        el: paginationEl,
                        clickable: true,
                        enabled: true,
                    },
                    autoplay: {
                        delay: 5000,
                    },
                    breakpoints: {
                        // >= 640px
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 18,
                        },
                        // >= 1024px
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                            pagination: {
                                enabled: false,
                            },
                        },
                    },

                });
            }

            function disable() {
                if (!infoCardsCarousel) return;

                infoCardsCarousel.destroy(true, true);
                infoCardsCarousel = null;
            }

            function check() {
                if (desktopMediaQueryList.matches && destroyOnDesktop) disable();
                else enable();
            }

            // initial check
            check();

            // on resize / breakpoint change
            desktopMediaQueryList.addEventListener?.("change", check) || desktopMediaQueryList.addListener(check);
        });



        $(".reviews__carousel").each(function () {
            const $el = $(this);

            let reviewsCarousel = null;

            const desktopMediaQueryList = window.matchMedia("(min-width: 1024px)");

            const destroyOnMobile = parseInt($el.data('destroy-on-mobile')) === 1;

            const nextButton = document.getElementById($el.data('next-button-id'));
            const prevButton = document.getElementById($el.data('prev-button-id'));
            const paginationEl = document.getElementById($el.data('pagination-id'));

            const reduceGapPx = (parseInt($el.data('reduce-gap-px')) || 0) * 2;

            const keepDesktopPagination = (parseInt($el.data('keep-desktop-pagination')) || 0) === 1;


            function enable() {
                if (reviewsCarousel) return;

                reviewsCarousel = new Swiper($el.get(0), {
                    modules: [Autoplay, Navigation, Pagination],
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: (16 - reduceGapPx),
                    speed: 1000,
                    allowTouchMove: true,
                    watchOverflow: false,
                    pagination: {
                        type: "bullets",
                        el: paginationEl,
                        clickable: true,
                        enabled: true,
                    },
                    autoplay: false,
                    navigation: {
                        enabled: false,
                        nextEl: nextButton,
                        prevEl: prevButton
                    },
                    breakpoints: {
                        // >= 640px
                        640: {
                            slidesPerView: 2,
                            spaceBetween: (18 - reduceGapPx),
                        },
                        // >= 1024px
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: (24 - reduceGapPx),
                            navigation: {
                                enabled: true,
                            },
                            pagination: {
                                enabled: keepDesktopPagination,
                            },
                        },
                    },

                });
            }

            function disable() {
                if (!reviewsCarousel) return;

                reviewsCarousel.destroy(true, true); // removes styles + events + inline transforms
                reviewsCarousel = null;
            }

            function check() {
                if (!desktopMediaQueryList.matches && destroyOnMobile) disable();
                else enable();
            }

            // initial check
            check();

            // on resize / breakpoint change
            desktopMediaQueryList.addEventListener?.("change", check) || desktopMediaQueryList.addListener(check);
        });



        $(".three-cols__carousel").each(function () {
            const $el = $(this);

            let threeColsCarousel = null;

            const desktopMediaQueryList = window.matchMedia("(min-width: 1024px)");

            const destroyOnDesktop = parseInt($el.data('destroy-on-desktop')) === 1;

            const paginationEl = document.getElementById($el.data('pagination-id'));


            function enable() {
                if (threeColsCarousel) return;

                threeColsCarousel = new Swiper($el.get(0), {
                    modules: [Autoplay, Pagination],
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 16,
                    speed: 1000,
                    allowTouchMove: true,
                    watchOverflow: false,
                    pagination: {
                        type: "bullets",
                        el: paginationEl,
                        clickable: true,
                        enabled: true,
                    },
                    autoplay: {
                        delay: 5000,
                    },
                    breakpoints: {
                        // >= 640
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 18,
                        },
                        // >= 1024px
                        1025: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                            pagination: {
                                enabled: false,
                            },
                        },
                    },

                });
            }

            function disable() {
                if (!threeColsCarousel) return;

                threeColsCarousel.destroy(true, true);
                threeColsCarousel = null;
            }

            function check() {
                if (desktopMediaQueryList.matches && destroyOnDesktop) disable();
                else enable();
            }

            // initial check
            check();

            // on resize / breakpoint change
            desktopMediaQueryList.addEventListener?.("change", check) || desktopMediaQueryList.addListener(check);
        });



        $(".testimonials__carousel").each(function () {
            const $el = $(this);

            let testimonialsCarousel = null;

            const nextButton = document.getElementById($el.data('next-button-id'));
            const prevButton = document.getElementById($el.data('prev-button-id'));
            const paginationEl = document.getElementById($el.data('pagination-id'));

            testimonialsCarousel = new Swiper($el.get(0), {
                modules: [Autoplay, Navigation, Pagination],
                loop: false,
                slidesPerView: 1,
                spaceBetween: 16,
                speed: 1000,
                autoHeight: true,
                allowTouchMove: true,
                watchOverflow: false,
                pagination: {
                    type: "bullets",
                    el: paginationEl,
                    clickable: true,
                    enabled: true,
                },
                autoplay: false,
                navigation: {
                    enabled: true,
                    nextEl: nextButton,
                    prevEl: prevButton
                }

            });

        });



        $(".post-cats__carousel").each(function () {

            function updateEdgeClasses(swiper) {
                swiper.el.classList.toggle(CLASS_AT_START, swiper.isBeginning);
                swiper.el.classList.toggle(CLASS_AT_END, swiper.isEnd);
            }

            const CLASS_AT_START = "is-at-start";
            const CLASS_AT_END   = "is-at-end";

            const $postCatsCarouselEl = $(this);

            const initialSlideIndex = $postCatsCarouselEl.find('.post-cats__item--active').parent().index();

            const nextButton = document.getElementById($postCatsCarouselEl.data('next-button-id'));
            const prevButton = document.getElementById($postCatsCarouselEl.data('prev-button-id'));

            const postCatsCarouselSwiperInstance = new Swiper($postCatsCarouselEl.get(0), {
                modules: [Navigation],
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                speed: 200,
                allowTouchMove: true,
                navigation: {
                    enabled: true,
                    nextEl: nextButton,
                    prevEl: prevButton
                },
                initialSlide: initialSlideIndex,
                on: {
                    init(swiper) {
                        // make sure edge flags are correct right after init
                        updateEdgeClasses(swiper);
                    },
                    // fires when activeIndex changes
                    slideChange(swiper) {
                        updateEdgeClasses(swiper);
                    },
                    resize(swiper) {
                        updateEdgeClasses(swiper);
                    },

                    reachBeginning(swiper) {
                        updateEdgeClasses(swiper);
                    },
                    reachEnd(swiper) {
                        updateEdgeClasses(swiper);
                    },
                    fromEdge(swiper) {
                        updateEdgeClasses(swiper);
                    },
                },

            });
        });



        $(".blog-posts-cards__carousel").each(function () {
            const $el = $(this);

            let blogCardsCarousel = null;

            const desktopMediaQueryList = window.matchMedia("(min-width: 1024px)");

            const destroyOnMobile = true;

            const reduceGapPx = (parseInt($el.data('reduce-gap-px')) || 0) * 2;

            const nextButton = document.getElementById($el.data('next-button-id'));
            const prevButton = document.getElementById($el.data('prev-button-id'));
            const paginationEl = document.getElementById($el.data('pagination-id'));


            function enable() {
                if (blogCardsCarousel) return;

                blogCardsCarousel = new Swiper($el.get(0), {
                    modules: [Autoplay, Navigation, Pagination],
                    loop: false,
                    slidesPerView: 3,
                    spaceBetween: (24 - reduceGapPx),
                    speed: 1000,
                    allowTouchMove: true,
                    watchOverflow: false,
                    pagination: {
                        el: paginationEl,
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="page-numbers ' + className + '">' + (index + 1) + "</span>";
                        },
                    },
                    autoplay: false,
                    navigation: {
                        enabled: true,
                        nextEl: nextButton,
                        prevEl: prevButton
                    }

                });
            }

            function disable() {
                if (!blogCardsCarousel) return;

                blogCardsCarousel.destroy(true, true); // removes styles + events + inline transforms
                blogCardsCarousel = null;
            }

            function check() {
                if (!desktopMediaQueryList.matches && destroyOnMobile) disable();
                else enable();
            }

            // initial check
            check();

            // on resize / breakpoint change
            desktopMediaQueryList.addEventListener?.("change", check) || desktopMediaQueryList.addListener(check);
        });

    });


})(jQuery);